export default __webpack_public_path__ + "static/media/mas-runner-1.dd2e748e.png";